module.exports = __webpack_public_path__ + "img/icon-new.00e7ad8d.png";